import {
	broncoURLENV,
} from '../ENV';

export const fetchEntertainmentContent = async (componentUUID) => {
    const res = await fetch(`${broncoURLENV}/entertainment/component/${componentUUID}/slideshow`);
    const json = await res.json();

    return json;
};